import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper, { PageCard, PageTitle, SectionH2, Para } from '../../components/Layout/PageWrapper';

function EuPolicy() {
  return (
    <PageWrapper>
      <Helmet>
        <title>EU Cookie Policy | VibeOfGames</title>
        <meta name="description" content="VibeOfGames EU Cookie Policy. Learn about how we use cookies in compliance with EU regulations." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vibeofgames.com/eu-policy" />
      </Helmet>
      <PageCard>
        <PageTitle>EU Cookie Policy</PageTitle>
        <SectionH2>What Are Cookies?</SectionH2>
        <Para>Cookies are small text files stored on your device when you visit a website. They help us remember your preferences and improve your experience.</Para>
        <SectionH2>How We Use Cookies</SectionH2>
        <Para>VibeOfGames uses cookies to enable core site functionality, analyze site usage, and display relevant advertisements via Google AdSense.</Para>
        <SectionH2>Your Choices</SectionH2>
        <Para>You can control cookie settings through your browser preferences. Note that disabling cookies may affect the functionality of certain features on our website.</Para>
        <SectionH2>Third Party Cookies</SectionH2>
        <Para>Our advertising partners, including Google AdSense, may place cookies on your device. These are governed by their own privacy policies.</Para>
        <SectionH2>Contact</SectionH2>
        <Para>For questions about our cookie policy, contact us at info@vibeofgames.com.</Para>
      </PageCard>
    </PageWrapper>
  );
}

export default EuPolicy;
